"use client";
import _objectWithoutProperties from '@babel/runtime/helpers/objectWithoutProperties';
import * as React from 'react';
import { Icon } from '../../Icon/Icon.web.js';

var _excluded = ["color", "size"];
var IconLightBulb = function IconLightBulb(_ref) {
  var _ref$color = _ref.color,
    color = _ref$color === undefined ? 'currentColor' : _ref$color,
    _ref$size = _ref.size,
    sizeProp = _ref$size === undefined ? '48px' : _ref$size,
    props = _objectWithoutProperties(_ref, _excluded);
  var size = sizeProp;
  return /*#__PURE__*/React.createElement(Icon, props, /*#__PURE__*/React.createElement("svg", {
    fill: "none",
    viewBox: "0 0 48 48",
    width: size,
    height: size
  }, /*#__PURE__*/React.createElement("path", {
    fill: color,
    fillRule: "evenodd",
    d: "M24.5 2v3h-1V2zm9.046 6.662 2.122-2.122-.708-.708-2.122 2.122zM8 18h3v-1H8zm29 0h3v-1h-3zm-21.838 9.045-2.122 2.122-.707-.707 2.121-2.122zm-.708-18.383L12.333 6.54l.708-.708 2.122 2.122zM32.84 27.045l2.122 2.122.707-.707-2.122-2.122zM19.042 33a1 1 0 0 1 1-1h8a1 1 0 1 1 0 2h-8a1 1 0 0 1-1-1m-2 0c0-.963.454-1.82 1.159-2.369a13.3 13.3 0 0 0-2.137-4.727 12.5 12.5 0 0 1-3.183-7.735l-.001-.024v-.025a11.12 11.12 0 0 1 22.24 0v.024l-.001.026a12.5 12.5 0 0 1-3.187 7.734 13.3 13.3 0 0 0-2.12 4.673A3 3 0 0 1 31.042 33c0 .768-.289 1.47-.764 2a3 3 0 0 1-2.236 5v.81a2.19 2.19 0 0 1-2.19 2.19h-3.62a2.19 2.19 0 0 1-2.19-2.19V40a3 3 0 0 1-2.236-5 3 3 0 0 1-.764-2m5 7v.81a.19.19 0 0 0 .19.19h3.62a.19.19 0 0 0 .19-.19V40zm-4.387-15.309A15.3 15.3 0 0 1 20.106 30h7.787a15.3 15.3 0 0 1 2.447-5.308l.033-.046.038-.042a10.5 10.5 0 0 0 2.709-6.509 9.12 9.12 0 0 0-18.24 0 10.5 10.5 0 0 0 2.705 6.51l.037.04zM20.042 36h8a1 1 0 1 1 0 2h-8a1 1 0 1 1 0-2m-.988-21.163a5.95 5.95 0 0 1 2.64-2.19l-.389-.92a6.95 6.95 0 0 0-4.245 6.392l1 .002a5.95 5.95 0 0 1 .994-3.284",
    clipRule: "evenodd"
  })));
};

export { IconLightBulb, IconLightBulb as default };
